import { useQuery } from "@apollo/client";
import { GET_STATS } from "@store/operations/analyticsOperations";

export const useGetStats = (pollInterval = 0) => useQuery(GET_STATS, { pollInterval });
